import React, { useState } from "react";
import css from "./comp.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function MaskItem({ text, path }) {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className={`${css.maskcontainer}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className={`${css.maskitem} ${isHovered ? css.maskitemAnimation : ""}`}
      >
        <p>{text}</p>
        <div className={css.learnmore} onClick={() => navigate(path)}>
          {t("了解更多") + "  >"}
        </div>
      </div>
    </div>
  );
}

export default React.memo(MaskItem);
